import { Component, h, Prop, State } from '@stencil/core';
import Document from '../../stories/assets/svg/tenant/document.svg';
import Leaf from '../../stories/assets/svg/tenant/leaf.svg';
import MapMarker from '../../stories/assets/svg/tenant/map-marker.svg';
import MapTick from '../../stories/assets/svg/tenant/map-tick.svg';
import Phone from '../../stories/assets/svg/tenant/phone.svg';
import Phone2 from '../../stories/assets/svg/tenant/phone-2.svg';
import PiggyBank from '../../stories/assets/svg/tenant/piggy-bank.svg';
import StarBadge from '../../stories/assets/svg/tenant/star-badge.svg';
import TeaBreak from '../../stories/assets/svg/tenant/tea-break.svg';
import Tick from '../../stories/assets/svg/tenant/tick.svg';
import ExclamationMark from '../../stories/assets/svg/tenant/exclamation-mark.svg';
import { SvgIcons } from './jui-svg-icon.model';

@Component({
  tag: 'jui-svg-icon',
  styleUrl: 'jui-svg-icon.scss',
  shadow: true
})
export class JuiSvgIcon {
  /**
   * The name of the SVG icon (without the `.svg` extension)
   */
  @Prop() name!: SvgIcons;

  /**
   * Optional size for the SVG (default: 100%)
   */
  @Prop() size = '100%';

  /**
   * Holds the SVG content after loading
   */
  @State() svgContent = '';

  componentDidUpdate() {
    this.loadSvg();
  }
  componentWillLoad(): void {
    this.loadSvg();
  }
  private loadSvg() {
    switch (this.name) {
      case 'document':
        this.svgContent = Document;
        break;
      case 'leaf':
        this.svgContent = Leaf;
        break;
      case 'map-marker':
        this.svgContent = MapMarker;
        break;
      case 'map-tick':
        this.svgContent = MapTick;
        break;
      case 'phone':
        this.svgContent = Phone;
        break;
      case 'exclamation-mark':
        this.svgContent = ExclamationMark;
        break;
      case 'phone-2':
        this.svgContent = Phone2;
        break;
      case 'piggy-bank':
        this.svgContent = PiggyBank;
        break;
      case 'star-badge':
        this.svgContent = StarBadge;
        break;
      case 'tea-break':
        this.svgContent = TeaBreak;
        break;
      case 'tick':
        this.svgContent = Tick;
        break;
      default:
        break;
    }
  }
  render() {
    if (!this.svgContent) {
      return null;
    }
    return <div class="svg-container" style={{ width: this.size }} innerHTML={this.svgContent}></div>;
  }
}
